<div class="w-full flex justify-end items-center xl:justify-between">
  @if (formToShow()) {
    <patient-portal-form-banner
      (fillForm)="handleFillForm($event)"
      [form]="formToShow()"
      [expanded]="false"
      class="ml-4 hidden xl:block" />
  } @else {
    @let appointment = nearest$ | async;
    @if (appointment) {
      <button
        class="flex items-center gap-3 rounded-lg p-4 ml-4 bg-primary-50 text-xs text-primary-800 hover:bg-primary-200 hover:cursor-pointer"
        (click)="goToAppointments()">
        <mat-icon
          class="w-4! h-4! text-primary-700"
          svgIcon="calendar-clock"></mat-icon>
        <p class="flex">
          Upcoming appointment:
          <span class="ml-2 font-bold">{{
            appointment?.startUtc | zonedDate: 'MMM dd, yyyy'
          }}</span>
        </p>
      </button>
    }
  }
  <div class="ml-auto flex gap-4 items-center">
    @if (telehealthCall.isOpen()) {
      <icaredx-telehealth-live-control
        variant="link"
        [patientName]="telehealthCall.activeAppointment()?.providerDisplayName ?? null"
        [mode]="telehealthCall.displayMode()"
        [unreadCount]="telehealthCall.unreadCount()"
        (activate)="goToOnlineMeeting()" />
    }
    <icaredx-button
      class="leading-normal"
      color="secondary"
      [class.pointer-events-none]="loadingProvider()"
      [attr.aria-disabled]="loadingProvider()"
      (clicked)="openFilePicker()">
      <div class="inline-flex items-center gap-x-2">
        @if (loadingFile()) {
          <icaredx-spinner size="small" class="text-white"></icaredx-spinner>
          <span>Uploading...</span>
        } @else {
          <mat-icon class="w-3.5! h-3.5!" svgIcon="file-plus"></mat-icon>
          <span>Add document</span>
        }
      </div>
    </icaredx-button>

    <icaredx-file-input
      #fileInput
      acceptableTypes="
        application/pdf,
        image/png,
        image/jpeg,
        application/vnd.openxmlformats-officedocument.wordprocessingml.document,
        application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
        text/plain"
      class="hidden">
    </icaredx-file-input>

    @if (loadingBookingIntent()) {
    } @else if (!shouldShowResumeBookingAction) {
      <icaredx-button
        class="leading-normal"
        color="primary"
        [class.pointer-events-none]="loadingProvider()"
        [attr.aria-disabled]="loadingProvider()"
        (clicked)="openNewAppointmentDialog()">
        <mat-icon
          class="mr-2 !w-3.5 !h-3.5"
          svgIcon="calendar-plus-2"></mat-icon>
        Book Appointment
      </icaredx-button>
    } @else {
      <icaredx-button
        class="leading-normal"
        color="primary"
        [class.pointer-events-none]="loadingProvider()"
        [attr.aria-disabled]="loadingProvider()"
        (clicked)="openCheckoutDialog()">
        <mat-icon
          class="mr-2 !w-3.5 !h-3.5"
          svgIcon="calendar-plus-2"></mat-icon>
        {{ resumeBookingLabel }}
      </icaredx-button>
    }
    <mat-icon class="mr-2 !text-gray-500" svgIcon="info-solid"></mat-icon>
  </div>
</div>
